import StaffForm from './StaffForm'
import AssignOutletModal from './AssignOutletModal'
import styles from './StaffDetail.css'
import EmployeeDeleteModal from './EmployeeDeleteModal'
import {
  SUBMITTING_UPDATE_EMPLOYEE,
  SUBMITTING_CREATE_EMPLOYEE
} from 'actions/employees/staff/constants'

class StaffDetail extends React.Component {
  render () {
    const {
      outlets,
      showAssignOutletModal,
      showEmployeeDeleteModal,
      employeeDetail,
      roles,
      formValues,
      onCancelDeleteEmployee,
      onConfirmDeleteEmployee,
      onClickDeleteEmployee,
      submitting
    } = this.props
    return (<div className={styles.wrapper}>
      <StaffForm
        outlets={outlets}
        roles={roles}
        onClickAssignOutlet={this.props.onClickFormAssignOutlet}
        employee={employeeDetail}
        onSubmit={this.props.onSubmit}
        formValues={this.props.formValues}
        onClickDeleteEmployee={onClickDeleteEmployee}
        selfView={this.props.selfView}
        disableSubmit={submitting === SUBMITTING_UPDATE_EMPLOYEE || submitting === SUBMITTING_CREATE_EMPLOYEE}
      />
      <AssignOutletModal
        show={showAssignOutletModal}
        outlets={outlets}
        onClickCancel={this.props.onClickCancelAssignOutletModal}
        onClickAssign={this.props.onClickConfirmAssignOutletModal}
        assignedOutletIds={formValues.outlets}
      />
      {employeeDetail && <EmployeeDeleteModal
        show={showEmployeeDeleteModal}
        onCancel={onCancelDeleteEmployee}
        onDelete={onConfirmDeleteEmployee}
        employee={employeeDetail}
      />}
    </div>)
  }

}

StaffDetail.propTypes = {
  outlets: React.PropTypes.array,
  onClickDeleteEmployee: React.PropTypes.func,
  onConfirmDeleteEmployee: React.PropTypes.func,
  onCancelDeleteEmployee: React.PropTypes.func,
  onClickCancelAssignOutletModal: React.PropTypes.func,
  onClickConfirmAssignOutletModal: React.PropTypes.func,
  onClickFormAssignOutlet: React.PropTypes.func,
  onSubmit: React.PropTypes.func,
  showAssignOutletModal: React.PropTypes.bool,
  showEmployeeDeleteModal: React.PropTypes.bool,
  employeeDetail: React.PropTypes.object,
  formValues: React.PropTypes.object,
  submitting: React.PropTypes.string
}

export default StaffDetail



// WEBPACK FOOTER //
// ./app/pages/Employees/Staff/StaffDetail/StaffDetail.js